import { Injectable, EventEmitter } from '@angular/core';
import { Observable } from 'rxjs';
import { UserType, AlertType } from '../../_models';
import * as _ from 'lodash';


@Injectable({
  providedIn: 'root'
})
export class AlertTypeService {
  data :AlertType[]
  notifier =new EventEmitter();
  constructor() {
    
    this.data=[    
      {id:1,name:"CommonEventCreation",userTypes:[ {id:8,name:"Employees",isChecked:false} ] },
      {id:2,name:"DailyWiseAttendanceRegistration",userTypes:[ {id:1,name:"Students",isChecked:false} ,{id:2,name:"Teachers",isChecked:false}] },
      {id:3,name:"EmployeesCreation",userTypes:[ {id:8,name:"Employees",isChecked:false} ] },
      {id:4,name:"PollCreation",userTypes:[ {id:8,name:"Employees",isChecked:false} ] },
      {id:5,name:"EventCreationForBatch",userTypes:[ {id:1,name:"Students",isChecked:false} ,{id:3,name:"Perants",isChecked:false}] },
      {id:6,name:"EventCreationForEmployees",userTypes:[ {id:8,name:"Employees",isChecked:false} ] },
      {id:7,name:"ExaminationResultPublishing",userTypes:[ {id:1,name:"Students",isChecked:false} ,{id:3,name:"Perants",isChecked:false}] },
      {id:8,name:"TimetablePeirodCancel",userTypes:[ {id:1,name:"Students",isChecked:false} ,{id:3,name:"Perants",isChecked:false},{id:8,name:"Employees",isChecked:false}] },
      {id:9,name:"ExaminationSchedulePublishing",userTypes:[ {id:1,name:"Students",isChecked:false} ,{id:3,name:"Perants",isChecked:false}] },
      {id:10,name:"feeCollectionCreation",userTypes:[ {id:1,name:"Students",isChecked:false} ,{id:3,name:"Perants",isChecked:false}] },
      {id:11,name:"feeSubmission",userTypes:[ {id:1,name:"Students",isChecked:false} ,{id:3,name:"Perants",isChecked:false}] },
      {id:12,name:"TransfreBatch",userTypes:[ {id:1,name:"Students",isChecked:false} ,{id:3,name:"Perants",isChecked:false}] },
      {id:13,name:"PerantsCreation",userTypes:[ {id:3,name:"Perants",isChecked:false}] },
      {id:14,name:"StudentsCreation",userTypes:[ {id:1,name:"Students",isChecked:false}] },
      {id:15,name:"SubjectWiseAttendanceRegistration",userTypes:[ {id:1,name:"Students",isChecked:false} ,{id:3,name:"Perants",isChecked:false}] },
      {id:16,name:"TimetablePeirodSwap",userTypes:[ {id:1,name:"Students",isChecked:false} ,{id:3,name:"Perants",isChecked:false},{id:8,name:"Employees",isChecked:false}] },
      {id:17,name:"leaveApproval",userTypes:[ {id:8,name:"Employees",isChecked:false} ] },
      {id:18,name:"TimetablePeirodSwapUpdate",userTypes:[ {id:1,name:"Students",isChecked:false} ,{id:3,name:"Perants",isChecked:false},{id:8,name:"Employees",isChecked:false}] },
      {id:19,name:"leaveCreation",userTypes:[ {id:8,name:"Employees",isChecked:false} ] },
  ]




  }
  
  getAll() :AlertType[]{
    return _.cloneDeep(this.data);
  }

  count ():number {
    return  this.data.length;
  }

  insert(item :AlertType){
    this.data.push(_.cloneDeep(item));
    this.notifier.emit( this.data);
  }
  update(item :AlertType){
    let i = this.data.findIndex(f=>f.id== item.id);
    if(i!=-1)
    {
      this.data[i]=_.cloneDeep(item);
    //  this.notifier.emit( this.data);
    }

  }

  remove(item :AlertType){
    let i = this.data.findIndex(f=>f.id== item.id);
    if(i!=-1)
    {
      this.data.splice(i,1);
    }
    this.notifier.emit( this.data);
  }
  


}


